import Commitment from "../models/Commitment";
import Utils from "../utils/Utils";
import ApiService from "./ApiService";
import CommitmentWithRelations from "../models/CommitmentWithRelations";
import Timesheet from "../models/Timesheet";
import Leave from "../models/Leave";
import { UpdateCommitmentStatusRequestModel } from "./openApi/api";

export default class CommitmentService {
  public static async adminUpdateStatus(commitmentId: string, model: UpdateCommitmentStatusRequestModel): Promise<string> {
    return new Promise((resolve, reject) => {
      ApiService.post(`/commitment/${commitmentId}/updateStatus`, model)
        .then((result) => {
          if (result.data) {
            resolve(result.data);
          }
        })
        .catch((addErr) => {
          reject(addErr);
        });
    });
  }

  public static async teammemberUpdateStatus(commitmentId: string, model: UpdateCommitmentStatusRequestModel): Promise<string> {
    return new Promise((resolve, reject) => {
      ApiService.post(`/teammember/commitment/${commitmentId}/updateStatus`, model)
        .then((result) => {
          if (result.data) {
            resolve(result.data);
          }
        })
        .catch((addErr) => {
          reject(addErr);
        });
    });
  }

  public static async getCommitmentsByTeammeberId(teamMemberId: string): Promise<Commitment[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/commitment/GetCommitmentByTeammemberId/${teamMemberId}`, "")
        .then((result) => {
          if (!result.data) {
            resolve([] as Commitment[]);
          } else {
            const retVal = [] as Commitment[];
            result.data.forEach((doc: any) => {
              const item = this.getCommitmentFromResponse(doc);
              retVal.push(item);
            });
            resolve(retVal);
          }
        })
        .catch((error) => {
          reject(`error in TeamMemberService.getCommitmentsByTeammeberId ->${error}`);
        });
    });
  }

  public static async getCommitmentsByLinemanager(linemanagerId: string): Promise<Commitment[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/commitment/GetCommitmentByLinemanagerId/${linemanagerId}`, "")
        .then((commitmentResult) => {
          if (!commitmentResult.data) {
            resolve([]);
          } else {
            const retVal = [] as Commitment[];
            commitmentResult.data.map((d: any) => {
              const commitment = this.getCommitmentFromResponse(d);
              retVal.push(commitment);
            });
            resolve(retVal);
          }
        })
        .catch((commitmentError) => reject("commitmentError => " + commitmentError));
    });
  }

  public static async get(id: string): Promise<Commitment | null> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/commitment/${id}`, "")
        .then((commitmentResult) => {
          if (!commitmentResult.data) {
            resolve(null);
          } else {
            const retVal = this.getCommitmentFromResponse(commitmentResult.data);
            resolve(retVal);
          }
        })
        .catch((commitmentError) => reject(commitmentError));
    });
  }
  public static async getByName(name: string): Promise<Commitment | null> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/commitment/GetByName/${name}`, "")
        .then((commitmentResult) => {
          if (!commitmentResult.data) {
            resolve(null);
          } else {
            const retVal = this.getCommitmentFromResponse(commitmentResult.data);

            resolve(retVal);
          }
        })
        .catch((commitmentError) => reject(commitmentError));
    });
  }

  public static async getCommitmentsAndRelationsByDateRange(dateRange: any): Promise<CommitmentWithRelations> {
    return new Promise((resolve, reject) => {
      ApiService.post(`/commitment/getCommitmentsRelations`, { startDate: dateRange.StartDate, endDate: dateRange.EndDate })
        .then((Result) => {
          if (!Result.data) {
            resolve({ commitments: [], timesheets: [], leaves: [] });
          } else {
            const retVal = this.getCommitmentRelations(Result);
            resolve(retVal);
          }
        })
        .catch((commitmentError) => reject("commitmentError => " + commitmentError));
    });
  }

  public static async getCommitmentsAndRelationsByLinemanagerIdAndDateRange(linemanagerId: string, dateRange: any): Promise<CommitmentWithRelations> {
    return new Promise((resolve, reject) => {
      ApiService.post(`/commitment/getCommitmentsRelations/admin?linemanagerId=${linemanagerId}`, {
        startDate: dateRange.StartDate,
        endDate: dateRange.EndDate,
      })
        .then((Result) => {
          if (!Result.data) {
            resolve({ commitments: [], timesheets: [], leaves: [] });
          } else {
            const retVal = this.getCommitmentRelations(Result);
            resolve(retVal);
          }
        })
        .catch((commitmentError) => reject("commitmentError => " + commitmentError));
    });
  }

  public static async getCommitmentsByCustomerId(customerId: string): Promise<Commitment[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/commitment/GetCommitmentByCustomerId/${customerId}`, "")
        .then((commitmentResult) => {
          if (!commitmentResult.data) {
            resolve([]);
          } else {
            const retVal = [] as Commitment[];
            commitmentResult.data.map((d: any) => {
              const commitment = this.getCommitmentFromResponse(d);
              retVal.push(commitment);
            });
            resolve(retVal);
          }
        })
        .catch((commitmentError) => reject("commitmentError => " + commitmentError));
    });
  }

  public static async getList(): Promise<Commitment[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/commitment`, "")
        .then((commitmentResult) => {
          if (!commitmentResult.data) {
            resolve([]);
          } else {
            const retVal = commitmentResult.data.map((doc: any) => {
              const item = this.getCommitmentFromResponse(doc);
              return item;
            });
            resolve(retVal);
          }
        })
        .catch((commitmentError) => reject(commitmentError));
    });
  }

  public static async update(model: Commitment): Promise<Commitment> {
    return new Promise((resolve, reject) => {
      if (model.EndDate) {
        model.EndDate = Utils.lastOfTime(model.EndDate);
      }
      if (model.StartDate) {
        model.StartDate = Utils.lastOfTime(model.StartDate);
      }
      ApiService.put("/commitment", model)
        .then((result) => {
          model.id = result.data;
          model.EndDate = model.EndDate ? new Date(model.EndDate) : null;
          resolve(model);
        })
        .catch((addErr) => {
          reject(addErr);
        });
    });
  }

  public static async set(model: Commitment): Promise<Commitment> {
    return new Promise((resolve, reject) => {
      ApiService.post("/commitment", model)
        .then((result) => {
          if (result.data) {
            model.id = result.data;
            resolve(model);
          }
        })
        .catch((addErr) => {
          reject(addErr);
        });
    });
  }

  public static async setV2(model: Commitment): Promise<Commitment> {
    return new Promise((resolve, reject) => {
      ApiService.post("/commitmentV2", model)
        .then((result) => {
          if (result.data) {
            model.id = result.data;
            resolve(model);
          }
        })
        .catch((addErr) => {
          reject(addErr);
        });
    });
  }

  public static async remove(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      ApiService.delete(`/commitment/${id}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  }

  private static getCommitmentRelations(model: any) {
    const retVal = { commitments: [], timesheets: [], leaves: [] } as CommitmentWithRelations;
    model.data.commitments.forEach((d: any) => {
      retVal.commitments.push(d);
    });

    model.data.timesheets.forEach((d: any) => {
      const timesheet = { id: d.id, ...d } as Timesheet;
      if (timesheet.Date) {
        timesheet.Date = Utils.vsDateToDatetime(d.Date);
      }
      retVal.timesheets.push(timesheet);
    });
    model.data.leaves.forEach((d: any) => {
      const leaves = { id: d.id, ...d } as Leave;
      if (leaves.Date) {
        leaves.Date = Utils.vsDateToDatetime(d.Date);
      }
      retVal.leaves.push(leaves);
    });
    return retVal;
  }
  private static getCommitmentFromResponse(model: any) {
    const retVal = { id: model.id, ...model } as Commitment;
    if (retVal.EndDate) {
      retVal.EndDate = new Date(model.EndDate);
    }
    if (retVal.StartDate) {
      retVal.StartDate = new Date(model.StartDate);
    }

    return retVal;
  }
}
